"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
class Utils {
    static mergeIBotRegistration(local, remote) {
        var _a;
        return {
            botId: (_a = local.botId) !== null && _a !== void 0 ? _a : remote.botId,
            name: local.name || remote.name,
            description: local.description || remote.description,
            iconUrl: local.iconUrl || remote.iconUrl,
            messagingEndpoint: local.messagingEndpoint || remote.messagingEndpoint,
            callingEndpoint: local.callingEndpoint || remote.callingEndpoint,
            configuredChannels: local.configuredChannels || remote.configuredChannels,
            isSingleTenant: local.isSingleTenant || remote.isSingleTenant,
        };
    }
}
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map